import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import api2 from "../../../../Component/axios_Interceptor/api2";
import url, { SERVER_ADDRESS } from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView2,
} from "../../../../Component/style/common_style";
import Manage_Live from "./Manage_Live";

const Container = styled.div<{ $height: number }>`
  width: 23rem;
  min-width: 23rem;
  height: ${(props) => `${props.$height}px`};
`;
const StickyBox = styled.div`
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  height: 100vh;
`;
const TitleArea = styled.div`
  div.bold {
    margin-bottom: 0.5rem;
    ${fontStyles.Bold}
    font-size: 20px;
  }
  div.semibold {
    margin-bottom: 0.5rem;
    ${fontStyles.semiBold}
    font-size: 20px;
  }
  div.red {
    margin-bottom: 3px;
    ${fontStyles.medium}
    color: #eb003b;
  }
  div.gray {
    color: #8e8e8e;
  }
`;
const PicBox = styled(CenterView)`
  position: relative;
  width: 6rem;
  height: 6rem;
  margin: 0.5rem 0rem 2rem 0rem;
  color: #c6c6c6;
  font-size: 24px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;
const BlockArea = styled(RowView2)`
  margin-top: 15px;
  input {
    flex: 1;
    padding: 0.8rem;
    ${fontStyles.regular}
    font-size: 16px;
    border: 1px solid #f0f0f0;
    outline: 0;
    border-radius: 8px;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
    &::placeholder {
      color: #c6c6c6;
    }
  }
  div {
    padding: 0.8rem 1.5rem;
    margin-left: 0.5rem;
    white-space: nowrap;
    ${fontStyles.semiBold}
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
`;

const LiveInfo = ({
  settingHeight,
  live_start,
  live_finish,
  setLive_start,
  setLive_finish,
  setLive_cancle_check,
}: {
  settingHeight: number;
  live_start: string;
  live_finish: string;
  setLive_start: React.Dispatch<React.SetStateAction<string>>;
  setLive_finish: React.Dispatch<React.SetStateAction<string>>;
  setLive_cancle_check: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { seq } = useParams();

  const [crt_dt, setCrt_dt] = useState("");
  const [live_title, setLive_title] = useState("");
  const [live_img, setLive_img] = useState("");
  const [live_limit, setLive_limit] = useState("");
  const [ban_nickname, set_Ban_Nickname] = useState("");

  const setting_ban_nickname = (e: React.ChangeEvent<HTMLInputElement>) =>
    set_Ban_Nickname(e.target.value);

  const get_live_info = async () => {
    try {
      const res = await api2.get(url.Communication_url.get_live_info, {
        params: { seq: seq },
      });
      setCrt_dt(res.data.crt_dt || "");
      setLive_title(res.data.live_title || "");
      setLive_img(
        res.data.live_img
          ? SERVER_ADDRESS + "openfile/" + res.data.live_img
          : ""
      );
      setLive_limit(res.data.live_limit || "");
      setLive_start(res.data.live_start || "");
      setLive_finish(res.data.live_finish || "");
      setLive_cancle_check(res.data.cancle_check === "y");
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  useEffect(() => {
    get_live_info();
  }, []);

  const Dow = (date: string) => {
    const idx = new Date(date).getDay();
    return ["일", "월", "화", "수", "목", "금", "토"][idx];
  };
  const live_timeReturn = (startDt: string, endDt: string) => {
    const date = startDt.slice(0, 10).replaceAll("-", "/");
    const startTime = Number(startDt.slice(11, 13));
    const endTime = Number(endDt.slice(11, 13));
    const ampm = (time: number) =>
      time < 12
        ? `오전 ${time}`
        : time === 12
        ? `오후 ${time}`
        : `오후 ${time - 12}`;

    return `${date}(${Dow(date)}) ${ampm(startTime)}:00 ~ ${ampm(endTime)}:00 `;
  };
  const current_dt = (date: string) => {
    const result = date.slice(0, 10).replaceAll("-", "/");
    return result;
  };

  const userBan = async () => {
    if (ban_nickname === "") {
      return;
    }
    if (!window.confirm(`${ban_nickname} 님을 차단하시겠습니까?`)) {
      return;
    }

    try {
      const res = await api.post(url.Communication_url.user_ban, {
        nickname: ban_nickname,
      });

      if (res.data === "성공") {
        alert("정상적으로 처리되었습니다.");
        set_Ban_Nickname("");
      } else {
        alert("요청 실패. 다시 실행해주세요.");
      }
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };

  return (
    <Container $height={settingHeight}>
      <TitleArea className="col">
        <div className="bold">{live_title}</div>
        <div className="red">
          {live_timeReturn(live_start, live_finish)}
          (최대 {live_limit}명)
        </div>
        <div className="gray">{current_dt(crt_dt)}</div>
      </TitleArea>

      <PicBox>{live_img && <Icon src={live_img} />}</PicBox>

      <StickyBox>
        <TitleArea>
          <div className="semibold">라이브 화면</div>
        </TitleArea>
        <Manage_Live seq={seq} />

        <BlockArea>
          <input
            value={ban_nickname}
            onChange={setting_ban_nickname}
            placeholder="닉네임을 입력해주세요."
          />
          <div onClick={userBan}>차단</div>
        </BlockArea>
      </StickyBox>
    </Container>
  );
};

export default LiveInfo;
